<template>
    <div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<div class="content">                
				<!-- <div class="container">
					<div class="row">
                        <div class="card success-card">
                            <div class="card-body">
                                <div class="success-cont">
                                    <i class="fas fa-check"></i>
                                    <h3>Pembelian Paket Berhasil!</h3>
                                    <p>Paket {{paketsales.nama_paket}}</p>
                                    
                                    <btn class="btn btn-primary view-inv-btn" @click.prevent="mulaiBelajar(paketsales)">
                                        Ayo Mulai Belajar
                                    </btn>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>	
			<!-- /Page Content -->
   
			<!-- Footer -->
				<layout-footer />
			<!-- /Footer -->
		   
		</div>


    </div>
		<!-- /Main Wrapper -->
</template>

<script>

import {mapGetters} from 'vuex'
// import Sidebar from '../Sidebar';
// import axios from 'axios';
// import 'jquery/dist/jquery.min.js';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import "datatables.net-dt/js/dataTables.dataTables";
// import "datatables.net-dt/css/jquery.dataTables.min.css";
// import $ from 'jquery'
// import Number  from 'vue-number-format'

export default {
    props: {
        koderef: String,
    },
    
	name: 'Referral',
	// data() {
	// 	return {
    //         kode_referral: '',
    //         link_referral: '',
	// 	}
	// },
	
    computed: {
        ...mapGetters({ 
            isLoggedIn: 'isLoggedIn',
            user: 'user',
        }),
    },
    created: function () {
        var parameters = this.$route.query
        // console.log(parameters)

        const koderef = this.$route.query.koderef
        // console.log(name)
        
        localStorage.setItem("vkode_referral", koderef);
        // this.link_referral = window.location.origin+"/referral?koderef="+localStorage.getItem("kodeRef");
        let timerInterval
            swal.fire({
            title: 'Kode Referral',
            html: 'kode referral '+localStorage.getItem("vkode_referral")+' berhasil ditambahkan!',
            timer: 1000,
            // icon: 'success',
            timerProgressBar: true,
            didOpen: () => {
                swal.showLoading()
                const b = swal.getHtmlContainer().querySelector('b')
                timerInterval = setInterval(() => {
                b.textContent = swal.getTimerLeft()
                }, 100)
            },
            willClose: () => {
                clearInterval(timerInterval)
            }
            }).then((result) => {
                if(this.isLoggedIn)
                    this.$router.push({name:'siswa-paket-belajar'}); 
                else
                    this.$router.push({name:'login-page'}); 
                // /* Read more about handling dismissals below */
                // if (result.dismiss === swal.DismissReason.timer) {
                //     console.log('I was closed by the timer')
                // }

            })
    },
	methods: {

    }
}
</script>


// WEBPACK FOOTER //
// src/components/Referral/index.vue